import { render } from "./MolecularGeneticsReport.vue?vue&type=template&id=55b6e9be"
import script from "./MolecularGeneticsReport.vue?vue&type=script&lang=js"
export * from "./MolecularGeneticsReport.vue?vue&type=script&lang=js"

import "./MolecularGeneticsReport.vue?vue&type=style&index=0&id=55b6e9be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__